import { useRef } from 'react';

// A photo with hazard areas drawn on it, as the Spot the Risk game in the FSM
// app shows it (nano-fibre-fsm screens/SpotTheRisk.jsx) — kept the same so a
// scene looks here exactly as it will on the phone. Everything is placed in
// fractions of the photo's width and height.

const pct = (n) => `${n * 100}%`;

// A photo with things laid over it. onTap gets the point as fractions.
// Never taller than most of the screen, so a portrait scene (they are
// phone-shaped) is whole on screen while hazards are marked on it, centred.
export function SpotPhoto({ src, onTap, children, className = '' }) {
  const box = useRef(null);
  const tap = (e) => {
    if (!onTap) return;
    const r = box.current.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width;
    const y = (e.clientY - r.top) / r.height;
    if (x >= 0 && x <= 1 && y >= 0 && y <= 1) onTap({ x, y, aspect: r.width / r.height });
  };
  return (
    <div ref={box} onClick={tap} role={onTap ? 'button' : undefined}
      className={`relative mx-auto w-fit max-w-full select-none overflow-hidden rounded-md bg-gray-900 ${onTap ? 'cursor-crosshair' : ''} ${className}`}>
      <img src={src} alt="" draggable={false} className="block max-h-[70vh] w-auto max-w-full" />
      {children}
    </div>
  );
}

// A hazard area: an ellipse (a circle on screen — see SceneEditor) with its number.
export function HazardArea({ h, n, tone = 'brand', onClick }) {
  const ring = {
    brand: 'border-brand bg-brand/20',
    found: 'border-emerald-400 bg-emerald-400/25',
    missed: 'border-dashed border-rose-400 bg-rose-500/20',
  }[tone];
  return (
    <span
      onClick={onClick ? (e) => { e.stopPropagation(); onClick(); } : undefined}
      className={`absolute flex items-center justify-center rounded-full border-[3px] ${ring} ${onClick ? 'cursor-pointer' : ''}`}
      style={{ left: pct(h.x - h.rx), top: pct(h.y - h.ry), width: pct(h.rx * 2), height: pct(h.ry * 2) }}>
      <span className="rounded-full bg-black/60 px-1.5 text-xs font-bold text-white">{n}</span>
    </span>
  );
}

// Where someone tapped.
export function TapMark({ x, y, n, onClick }) {
  return (
    <span
      onClick={onClick ? (e) => { e.stopPropagation(); onClick(); } : undefined}
      className="absolute flex h-8 w-8 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-white bg-amber-500 text-sm font-bold text-white shadow-lg"
      style={{ left: pct(x), top: pct(y) }}>
      {n}
    </span>
  );
}
